// The few icons the components draw themselves, lucide's paths inline so
// nothing is fetched. An app brings its own for anything else.
import type { JSX } from "preact";

type P = JSX.IntrinsicElements["svg"];
const icon = (d: string[]) => (p: P) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" {...p}>
    {d.map((x) => <path d={x} />)}
  </svg>
);

export const X = icon(["M18 6 6 18", "m6 6 12 12"]);
export const Check = icon(["M20 6 9 17l-5-5"]);
export const ChevronDown = icon(["m6 9 6 6 6-6"]);
export const ChevronUp = icon(["m18 15-6-6-6 6"]);
export const ChevronRight = icon(["m9 18 6-6-6-6"]);
export const Copy = icon(["M8 8m0 2a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H10a2 2 0 0 1-2-2z", "M4 16c-1.1 0-2-.9-2-2V4c0-1.1.9-2 2-2h10c1.1 0 2 .9 2 2"]);
export const Circle = (p: P) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true" {...p}><circle cx="12" cy="12" r="5" /></svg>
);
